import { css } from '@emotion/react';
import BusinessIcon from '@mui/icons-material/Business';
import { Box, Typography, useTheme } from '@mui/material';
import React, { FC } from 'react';

import { borderGrey } from '@styles/colors';

type LogoAndAddressProps = {
  logoUrl: string | null;
  companyName?: string;
  maxWidth?: string;
  DefaultIcon?: React.FC;
  roundCorners?: boolean;
};

const LogoAndAddress: FC<LogoAndAddressProps> = ({
  logoUrl,
  companyName = '',
  maxWidth = '80px',
  DefaultIcon = BusinessIcon,
  roundCorners = false,
}) => {
  const theme = useTheme();

  if (logoUrl) {
    return (
      <img
        src={logoUrl}
        alt="Logo"
        css={css`
          max-width: ${maxWidth};
          width: 100%;
          height: 100%;
          border-radius: ${roundCorners ? theme.spacing(1) : 0};
          display: block;
        `}
      />
    );
  }

  if (!logoUrl && companyName) {
    return (
      <Typography variant="h4" color="text.primary" component="span">
        {companyName}
      </Typography>
    );
  }

  return (
    <Box
      width="80px"
      height="80px"
      marginX="auto"
      display="flex"
      alignItems="center"
      justifyContent="center"
      border={`1px solid ${borderGrey}`}
      borderRadius={3}
    >
      <DefaultIcon
        sx={{
          width: '40px',
          height: '40px',
          color: 'text.secondary',
        }}
      />
    </Box>
  );
};

export default LogoAndAddress;
